/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedAccessDeniedRouteImport } from './routes/_authenticated/access-denied'
import { Route as AuthenticatedUsuariosIndexRouteImport } from './routes/_authenticated/usuarios/index'
import { Route as AuthenticatedRegistrationsIndexRouteImport } from './routes/_authenticated/registrations/index'
import { Route as AuthenticatedReceiptsIndexRouteImport } from './routes/_authenticated/receipts/index'
import { Route as AuthenticatedExecutionsIndexRouteImport } from './routes/_authenticated/executions/index'
import { Route as AuthenticatedDocumentacionApiIndexRouteImport } from './routes/_authenticated/documentacion-api/index'
import { Route as AuthenticatedDashboardIndexRouteImport } from './routes/_authenticated/dashboard/index'
import { Route as AuthenticatedConsultasIndexRouteImport } from './routes/_authenticated/consultas/index'
import { Route as AuthenticatedConfiguracionIndexRouteImport } from './routes/_authenticated/configuracion/index'
import { Route as AuthenticatedBajasIndexRouteImport } from './routes/_authenticated/bajas/index'
import { Route as AuthenticatedRegistrationsRegistrationIdIndexRouteImport } from './routes/_authenticated/registrations/$registrationId/index'
import { Route as AuthenticatedExecutionsExecutionIdIndexRouteImport } from './routes/_authenticated/executions/$executionId/index'
import { Route as AuthenticatedConsultasInquiryIdIndexRouteImport } from './routes/_authenticated/consultas/$inquiryId/index'
import { Route as AuthenticatedBajasBajaIdIndexRouteImport } from './routes/_authenticated/bajas/$bajaId/index'

const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedAccessDeniedRoute =
  AuthenticatedAccessDeniedRouteImport.update({
    id: '/access-denied',
    path: '/access-denied',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedUsuariosIndexRoute =
  AuthenticatedUsuariosIndexRouteImport.update({
    id: '/usuarios/',
    path: '/usuarios/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRegistrationsIndexRoute =
  AuthenticatedRegistrationsIndexRouteImport.update({
    id: '/registrations/',
    path: '/registrations/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedReceiptsIndexRoute =
  AuthenticatedReceiptsIndexRouteImport.update({
    id: '/receipts/',
    path: '/receipts/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedExecutionsIndexRoute =
  AuthenticatedExecutionsIndexRouteImport.update({
    id: '/executions/',
    path: '/executions/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDocumentacionApiIndexRoute =
  AuthenticatedDocumentacionApiIndexRouteImport.update({
    id: '/documentacion-api/',
    path: '/documentacion-api/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDashboardIndexRoute =
  AuthenticatedDashboardIndexRouteImport.update({
    id: '/dashboard/',
    path: '/dashboard/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedConsultasIndexRoute =
  AuthenticatedConsultasIndexRouteImport.update({
    id: '/consultas/',
    path: '/consultas/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedConfiguracionIndexRoute =
  AuthenticatedConfiguracionIndexRouteImport.update({
    id: '/configuracion/',
    path: '/configuracion/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedBajasIndexRoute = AuthenticatedBajasIndexRouteImport.update({
  id: '/bajas/',
  path: '/bajas/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedRegistrationsRegistrationIdIndexRoute =
  AuthenticatedRegistrationsRegistrationIdIndexRouteImport.update({
    id: '/registrations/$registrationId/',
    path: '/registrations/$registrationId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedExecutionsExecutionIdIndexRoute =
  AuthenticatedExecutionsExecutionIdIndexRouteImport.update({
    id: '/executions/$executionId/',
    path: '/executions/$executionId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedConsultasInquiryIdIndexRoute =
  AuthenticatedConsultasInquiryIdIndexRouteImport.update({
    id: '/consultas/$inquiryId/',
    path: '/consultas/$inquiryId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedBajasBajaIdIndexRoute =
  AuthenticatedBajasBajaIdIndexRouteImport.update({
    id: '/bajas/$bajaId/',
    path: '/bajas/$bajaId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/access-denied': typeof AuthenticatedAccessDeniedRoute
  '/bajas/': typeof AuthenticatedBajasIndexRoute
  '/configuracion/': typeof AuthenticatedConfiguracionIndexRoute
  '/consultas/': typeof AuthenticatedConsultasIndexRoute
  '/dashboard/': typeof AuthenticatedDashboardIndexRoute
  '/documentacion-api/': typeof AuthenticatedDocumentacionApiIndexRoute
  '/executions/': typeof AuthenticatedExecutionsIndexRoute
  '/receipts/': typeof AuthenticatedReceiptsIndexRoute
  '/registrations/': typeof AuthenticatedRegistrationsIndexRoute
  '/usuarios/': typeof AuthenticatedUsuariosIndexRoute
  '/bajas/$bajaId/': typeof AuthenticatedBajasBajaIdIndexRoute
  '/consultas/$inquiryId/': typeof AuthenticatedConsultasInquiryIdIndexRoute
  '/executions/$executionId/': typeof AuthenticatedExecutionsExecutionIdIndexRoute
  '/registrations/$registrationId/': typeof AuthenticatedRegistrationsRegistrationIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/access-denied': typeof AuthenticatedAccessDeniedRoute
  '/bajas': typeof AuthenticatedBajasIndexRoute
  '/configuracion': typeof AuthenticatedConfiguracionIndexRoute
  '/consultas': typeof AuthenticatedConsultasIndexRoute
  '/dashboard': typeof AuthenticatedDashboardIndexRoute
  '/documentacion-api': typeof AuthenticatedDocumentacionApiIndexRoute
  '/executions': typeof AuthenticatedExecutionsIndexRoute
  '/receipts': typeof AuthenticatedReceiptsIndexRoute
  '/registrations': typeof AuthenticatedRegistrationsIndexRoute
  '/usuarios': typeof AuthenticatedUsuariosIndexRoute
  '/bajas/$bajaId': typeof AuthenticatedBajasBajaIdIndexRoute
  '/consultas/$inquiryId': typeof AuthenticatedConsultasInquiryIdIndexRoute
  '/executions/$executionId': typeof AuthenticatedExecutionsExecutionIdIndexRoute
  '/registrations/$registrationId': typeof AuthenticatedRegistrationsRegistrationIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/_authenticated/access-denied': typeof AuthenticatedAccessDeniedRoute
  '/_authenticated/bajas/': typeof AuthenticatedBajasIndexRoute
  '/_authenticated/configuracion/': typeof AuthenticatedConfiguracionIndexRoute
  '/_authenticated/consultas/': typeof AuthenticatedConsultasIndexRoute
  '/_authenticated/dashboard/': typeof AuthenticatedDashboardIndexRoute
  '/_authenticated/documentacion-api/': typeof AuthenticatedDocumentacionApiIndexRoute
  '/_authenticated/executions/': typeof AuthenticatedExecutionsIndexRoute
  '/_authenticated/receipts/': typeof AuthenticatedReceiptsIndexRoute
  '/_authenticated/registrations/': typeof AuthenticatedRegistrationsIndexRoute
  '/_authenticated/usuarios/': typeof AuthenticatedUsuariosIndexRoute
  '/_authenticated/bajas/$bajaId/': typeof AuthenticatedBajasBajaIdIndexRoute
  '/_authenticated/consultas/$inquiryId/': typeof AuthenticatedConsultasInquiryIdIndexRoute
  '/_authenticated/executions/$executionId/': typeof AuthenticatedExecutionsExecutionIdIndexRoute
  '/_authenticated/registrations/$registrationId/': typeof AuthenticatedRegistrationsRegistrationIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/access-denied'
    | '/bajas/'
    | '/configuracion/'
    | '/consultas/'
    | '/dashboard/'
    | '/documentacion-api/'
    | '/executions/'
    | '/receipts/'
    | '/registrations/'
    | '/usuarios/'
    | '/bajas/$bajaId/'
    | '/consultas/$inquiryId/'
    | '/executions/$executionId/'
    | '/registrations/$registrationId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/access-denied'
    | '/bajas'
    | '/configuracion'
    | '/consultas'
    | '/dashboard'
    | '/documentacion-api'
    | '/executions'
    | '/receipts'
    | '/registrations'
    | '/usuarios'
    | '/bajas/$bajaId'
    | '/consultas/$inquiryId'
    | '/executions/$executionId'
    | '/registrations/$registrationId'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/_authenticated/access-denied'
    | '/_authenticated/bajas/'
    | '/_authenticated/configuracion/'
    | '/_authenticated/consultas/'
    | '/_authenticated/dashboard/'
    | '/_authenticated/documentacion-api/'
    | '/_authenticated/executions/'
    | '/_authenticated/receipts/'
    | '/_authenticated/registrations/'
    | '/_authenticated/usuarios/'
    | '/_authenticated/bajas/$bajaId/'
    | '/_authenticated/consultas/$inquiryId/'
    | '/_authenticated/executions/$executionId/'
    | '/_authenticated/registrations/$registrationId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/access-denied': {
      id: '/_authenticated/access-denied'
      path: '/access-denied'
      fullPath: '/access-denied'
      preLoaderRoute: typeof AuthenticatedAccessDeniedRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/usuarios/': {
      id: '/_authenticated/usuarios/'
      path: '/usuarios'
      fullPath: '/usuarios/'
      preLoaderRoute: typeof AuthenticatedUsuariosIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/registrations/': {
      id: '/_authenticated/registrations/'
      path: '/registrations'
      fullPath: '/registrations/'
      preLoaderRoute: typeof AuthenticatedRegistrationsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/receipts/': {
      id: '/_authenticated/receipts/'
      path: '/receipts'
      fullPath: '/receipts/'
      preLoaderRoute: typeof AuthenticatedReceiptsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/executions/': {
      id: '/_authenticated/executions/'
      path: '/executions'
      fullPath: '/executions/'
      preLoaderRoute: typeof AuthenticatedExecutionsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/documentacion-api/': {
      id: '/_authenticated/documentacion-api/'
      path: '/documentacion-api'
      fullPath: '/documentacion-api/'
      preLoaderRoute: typeof AuthenticatedDocumentacionApiIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard/': {
      id: '/_authenticated/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof AuthenticatedDashboardIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/consultas/': {
      id: '/_authenticated/consultas/'
      path: '/consultas'
      fullPath: '/consultas/'
      preLoaderRoute: typeof AuthenticatedConsultasIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/configuracion/': {
      id: '/_authenticated/configuracion/'
      path: '/configuracion'
      fullPath: '/configuracion/'
      preLoaderRoute: typeof AuthenticatedConfiguracionIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/bajas/': {
      id: '/_authenticated/bajas/'
      path: '/bajas'
      fullPath: '/bajas/'
      preLoaderRoute: typeof AuthenticatedBajasIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/registrations/$registrationId/': {
      id: '/_authenticated/registrations/$registrationId/'
      path: '/registrations/$registrationId'
      fullPath: '/registrations/$registrationId/'
      preLoaderRoute: typeof AuthenticatedRegistrationsRegistrationIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/executions/$executionId/': {
      id: '/_authenticated/executions/$executionId/'
      path: '/executions/$executionId'
      fullPath: '/executions/$executionId/'
      preLoaderRoute: typeof AuthenticatedExecutionsExecutionIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/consultas/$inquiryId/': {
      id: '/_authenticated/consultas/$inquiryId/'
      path: '/consultas/$inquiryId'
      fullPath: '/consultas/$inquiryId/'
      preLoaderRoute: typeof AuthenticatedConsultasInquiryIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/bajas/$bajaId/': {
      id: '/_authenticated/bajas/$bajaId/'
      path: '/bajas/$bajaId'
      fullPath: '/bajas/$bajaId/'
      preLoaderRoute: typeof AuthenticatedBajasBajaIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedAccessDeniedRoute: typeof AuthenticatedAccessDeniedRoute
  AuthenticatedBajasIndexRoute: typeof AuthenticatedBajasIndexRoute
  AuthenticatedConfiguracionIndexRoute: typeof AuthenticatedConfiguracionIndexRoute
  AuthenticatedConsultasIndexRoute: typeof AuthenticatedConsultasIndexRoute
  AuthenticatedDashboardIndexRoute: typeof AuthenticatedDashboardIndexRoute
  AuthenticatedDocumentacionApiIndexRoute: typeof AuthenticatedDocumentacionApiIndexRoute
  AuthenticatedExecutionsIndexRoute: typeof AuthenticatedExecutionsIndexRoute
  AuthenticatedReceiptsIndexRoute: typeof AuthenticatedReceiptsIndexRoute
  AuthenticatedRegistrationsIndexRoute: typeof AuthenticatedRegistrationsIndexRoute
  AuthenticatedUsuariosIndexRoute: typeof AuthenticatedUsuariosIndexRoute
  AuthenticatedBajasBajaIdIndexRoute: typeof AuthenticatedBajasBajaIdIndexRoute
  AuthenticatedConsultasInquiryIdIndexRoute: typeof AuthenticatedConsultasInquiryIdIndexRoute
  AuthenticatedExecutionsExecutionIdIndexRoute: typeof AuthenticatedExecutionsExecutionIdIndexRoute
  AuthenticatedRegistrationsRegistrationIdIndexRoute: typeof AuthenticatedRegistrationsRegistrationIdIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAccessDeniedRoute: AuthenticatedAccessDeniedRoute,
  AuthenticatedBajasIndexRoute: AuthenticatedBajasIndexRoute,
  AuthenticatedConfiguracionIndexRoute: AuthenticatedConfiguracionIndexRoute,
  AuthenticatedConsultasIndexRoute: AuthenticatedConsultasIndexRoute,
  AuthenticatedDashboardIndexRoute: AuthenticatedDashboardIndexRoute,
  AuthenticatedDocumentacionApiIndexRoute:
    AuthenticatedDocumentacionApiIndexRoute,
  AuthenticatedExecutionsIndexRoute: AuthenticatedExecutionsIndexRoute,
  AuthenticatedReceiptsIndexRoute: AuthenticatedReceiptsIndexRoute,
  AuthenticatedRegistrationsIndexRoute: AuthenticatedRegistrationsIndexRoute,
  AuthenticatedUsuariosIndexRoute: AuthenticatedUsuariosIndexRoute,
  AuthenticatedBajasBajaIdIndexRoute: AuthenticatedBajasBajaIdIndexRoute,
  AuthenticatedConsultasInquiryIdIndexRoute:
    AuthenticatedConsultasInquiryIdIndexRoute,
  AuthenticatedExecutionsExecutionIdIndexRoute:
    AuthenticatedExecutionsExecutionIdIndexRoute,
  AuthenticatedRegistrationsRegistrationIdIndexRoute:
    AuthenticatedRegistrationsRegistrationIdIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
